import { types } from "../types/types";
import moment from 'moment';

export const controlPresenciaReducer = (state = {}, action) => {

    switch (action.type) {
        case types.cpConsultarFixatgeJornada:
            return { ...state, llistatFixatges: action.llistatFixatges };

        case types.cpDiaFixatgeConsultat:
            return { ...state, fixatgeDiaConsultat: action.fixatgeDiaConsultat };

        case types.cpDiaIncidenciaConsultat:
            return { ...state, incidenciaDiaConsultat: action.incidenciaDiaConsultat };

        case types.cpConsultarIncidenciaJornada:
            return { ...state, llistatIncidencies: action.llistatIncidencies };

        case types.cpJornadaIniciada:
            return { ...state, jornadaIniciada: action.iniciada };

        case types.cpJornadaFinalitzada:
            return { ...state, jornadaFinalitzada: action.finalitzada };

        case types.cpJornadaIncidencia:
            return { ...state, jornadaIncidencia: action.incidencia };

        case types.cpConsultarFixatgeSetmanaActual:
            return { ...state, llistatFixatgesSetmana: action.llistatFixatgesSetmana };

        case types.cpConsultarIncidenciesSetmanaActual:
            return { ...state, llistatIncidenciesSetmana: action.llistatIncidenciesSetmana };

        case types.cpDetallSetmanaComplet: {
            // Derivar jornadaIniciada/Finalitzada des dels fixatges d'avui
            // Així RegistreScreen sap quin formulari mostrar sense crides addicionals
            const avui = moment().format('YYYY-MM-DD');
            const diaAvui = action.payload?.fixatges_setmanals?.find(d => d.dia === avui);
            const fixatgesAvui = diaAvui?.fixatges ?? [];

            let jornadaIniciada = false;
            let jornadaFinalitzada = false;
            let jornadaIncidencia = false;

            if (fixatgesAvui.length > 0) {
                const ultim = fixatgesAvui[fixatgesAvui.length - 1];
                if (ultim.IdTipus_Fixatge === '1' || ultim.IdTipus_Fixatge === '2') {
                    jornadaIniciada = true;
                } else if (ultim.IdTipus_Fixatge === '3' || ultim.IdTipus_Fixatge === '4') {
                    jornadaFinalitzada = true;
                } else {
                    jornadaIncidencia = true;
                }
            }

            return {
                ...state,
                detallSetmana:    action.payload,
                jornadaIniciada,
                jornadaFinalitzada,
                jornadaIncidencia,
            };
        }

        case types.cpLoadingDetallSetmana:
            return { ...state, loadingDetallSetmana: action.payload };

        case types.cpActualitzarDiaDetallSetmana: {
            if (!state.detallSetmana) return state;
            const diaActualitzat = action.payload;
            const avui = moment().format('YYYY-MM-DD');

            const novaLlistaFixatges = state.detallSetmana.fixatges_setmanals.map(d =>
                d.dia === diaActualitzat.dia
                    ? { ...d, fixatges: diaActualitzat.fixatges, existeixAlerta: diaActualitzat.existeixAlerta, idTipusAlerta: diaActualitzat.idTipusAlerta, computHores: diaActualitzat.computHores }
                    : d
            );

            const altresIncidencies = (state.detallSetmana.llistatIncidencies ?? []).filter(e => {
                const inici = e.DataInici_IncidenciaFix?.substring(0, 10);
                const fi    = e.DataFi_IncidenciaFix?.substring(0, 10);
                return !(diaActualitzat.dia >= inici && diaActualitzat.dia <= fi);
            });
            const novesIncidencies = [...altresIncidencies, ...(diaActualitzat.incidencies ?? [])];

            // Si el dia actualitzat és avui, recalcular estat jornada
            let jornadaExtra = {};
            if (diaActualitzat.dia === avui) {
                const fixatgesAvui = diaActualitzat.fixatges ?? [];
                let jornadaIniciada = false;
                let jornadaFinalitzada = false;
                let jornadaIncidencia = false;
                if (fixatgesAvui.length > 0) {
                    const ultim = fixatgesAvui[fixatgesAvui.length - 1];
                    if (ultim.IdTipus_Fixatge === '1' || ultim.IdTipus_Fixatge === '2') jornadaIniciada = true;
                    else if (ultim.IdTipus_Fixatge === '3' || ultim.IdTipus_Fixatge === '4') jornadaFinalitzada = true;
                    else jornadaIncidencia = true;
                }
                jornadaExtra = { jornadaIniciada, jornadaFinalitzada, jornadaIncidencia };
            }

            return {
                ...state,
                ...jornadaExtra,
                detallSetmana: {
                    ...state.detallSetmana,
                    fixatges_setmanals: novaLlistaFixatges,
                    llistatIncidencies: novesIncidencies,
                }
            };
        }

        default:
            return state;
    }
}